export default "__VITE_ASSET__Dfz0fXQY__"